(function () {
  function scrollTrack(selector, dir) {
    var el = document.querySelector(selector);
    if (!el) return;
    var amount = Math.max(el.clientWidth * 0.85, 220);
    el.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var original = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('wate:cart:added', { detail: { id: id } }));
        window.location.href = cartUrl;
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.innerHTML = original;
      });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-wate-add]');
    if (add) {
      e.preventDefault();
      addToCart(add);
      return;
    }
    var scroller = e.target.closest('[data-wate-scroll]');
    if (scroller) {
      e.preventDefault();
      scrollTrack(scroller.getAttribute('data-wate-scroll'), parseInt(scroller.getAttribute('data-dir'), 10) || 1);
    }
  });

  // total height of announcement + header so the hero can sit fully behind them
  function setOverlayOffset() {
    if (!document.body.classList.contains('wate-home')) return;
    var ann = document.querySelector('.announcement-bar-section');
    var head = document.querySelector('.section-header');
    var total = (ann ? ann.offsetHeight : 0) + (head ? head.offsetHeight : 0);
    if (total > 0) {
      document.documentElement.style.setProperty('--wate-overlay-offset', total + 'px');
    }
  }

  setOverlayOffset();
  window.addEventListener('load', setOverlayOffset);
  window.addEventListener('resize', setOverlayOffset);
})();
